// client/src/coms/auth/providerSessions.js
const STORAGE_KEY = 'vox_provider_sessions_v1';

function safeJsonParse(value, fallback = null) {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function readAllRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? safeJsonParse(raw, {}) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAllRaw(value) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value && typeof value === 'object' ? value : {}));
  } catch {}
}

export function normalizeProviderKey(value) {
  return String(value || '').trim().toLowerCase();
}

export function getAllProviderSessions() {
  return readAllRaw();
}

export function getProviderSession(provider) {
  const key = normalizeProviderKey(provider);
  if (!key) return null;
  const all = readAllRaw();
  const session = all[key];
  return session && typeof session === 'object' ? session : null;
}

export function setProviderSession(provider, session) {
  const key = normalizeProviderKey(provider);
  if (!key) return null;
  const all = readAllRaw();
  all[key] = {
    ...(all[key] && typeof all[key] === 'object' ? all[key] : {}),
    ...(session && typeof session === 'object' ? session : {}),
    provider: key,
    updatedAt: Date.now(),
  };
  writeAllRaw(all);
  return all[key];
}

export function clearProviderSession(provider) {
  const key = normalizeProviderKey(provider);
  if (!key) return;
  const all = readAllRaw();
  delete all[key];
  writeAllRaw(all);
}

export function listConnectedProviders() {
  const all = readAllRaw();
  return Object.keys(all).filter((key) => {
    const value = all[key];
    return value && typeof value === 'object' && value.status !== 'disconnected';
  });
}
